<section class="margem-top servicos">
  <div class="servicos-titulo">Serviços digitais disponíveis na plataforma</div>
  <div class="servicos-texto">Selecione um dos serviços abaixo clicando sobre eles:</div>
  <div class="servicos-container">
    <div *ngIf="!cadastroEmUso && exibirMenu('CAIXA POSTAL ELETRÔNICA')" class="servicos-item centralizar" [class.disabled]="nivelContribuinte == 'bronze'"
      title="{{ nivelContribuinte !== 'bronze' ? 'Caixa Postal' : 'Este recurso está disponível somente para os níveis Prata e Ouro do acesso Gov.br' }}"
      (click)="nivelContribuinte !== 'bronze' && this.abrirCaixaPostal()" tabindex="0">
      <div class="row">
        <span class="servicos-item__texto-maior">CAIXA POSTAL ELETRÔNICA</span>
      </div>
      <div class="row">
        <span class="servicos-item__texto col">Comunicações oficiais da Secretaria de Fazenda</span>
      </div>
    </div>
    <div *ngIf="!cadastroEmUso && exibirMenu('PROCURAÇÃO ELETRÔNICA')" class="servicos-item centralizar" [class.disabled]="nivelContribuinte == 'bronze'"
      title="{{ nivelContribuinte !== 'bronze' ? 'Procuração Eletrônica': 'Este recurso está disponível somente para os níveis Prata e Ouro do acesso Gov.br' }}"
      [routerLink]="nivelContribuinte !== 'bronze' ? ['/procuracao'] : []">
      <div class="row">
        <span class="servicos-item__texto-maior col">PROCURAÇÃO ELETRÔNICA</span>
      </div>
      <div class="row">
        <span class="servicos-item__texto col">Outorga representação para atos junto à SEFAZ para terceiros</span>
      </div>
    </div>
    <div *ngIf="!cadastroEmUso && exibirMenu('REFIS')" class="servicos-item centralizar" [class.disabled]="nivelContribuinte == 'bronze'"
      title="{{ nivelContribuinte !== 'bronze' ? 'REFIS': 'Este recurso está disponível somente para os níveis Prata e Ouro do acesso Gov.br' }}"
      [routerLink]="nivelContribuinte !== 'bronze' ? ['/refis'] : []">
      <div class="row">
        <span class="servicos-item__texto-maior col">REFIS</span>
      </div>
      <div class="row">
        <span class="servicos-item__texto col">Adesão e Acompanhamento (ICMS, ITCD e outras receitas)</span>
      </div>
    </div>
    <div *ngIf="!cadastroEmUso && exibirMenu('PORTAL DE NEGOCIAÇÃO DE DÉBITOS')" class="servicos-item centralizar" (click)="abrirModal()" tabindex="0">
      <div class="row">
        <span class="servicos-item__texto-maior">PORTAL DE NEGOCIAÇÃO DE DÉBITOS</span>
      </div>
      <div class="row">
        <span class="servicos-item__texto col">Negociação de débitos e dívida ativa</span>
      </div>
    </div>
    <!-- <div *ngIf="!cadastroEmUso && exibirMenu('NFA-e') && (dadosIntegracao.sessao.cadastro.codigo == 68430 || dadosIntegracao.sessao.cadastro.codigo == 1835445 || dadosIntegracao.sessao.cadastro.codigo == 1620701)" class="servicos-item centralizar" tabindex="0" (click)="abrirModalNfae()">
      <div class="row">
        <span class="servicos-item__texto-maior col">NFA-e</span>
      </div>
      <div class="row">
        <span class="servicos-item__texto col subtituloNfe">Emitir, consultar, solicitar cancelamento e emitir parecer
          de notas fiscais avulsas eletrônicas</span>
      </div>
      <div class="row iconeNfe">
        <img class="iconeNfe_img"
          [src]="modoEscuro ? '../../../assets/images/icones/white-file-invoice-dollar-solid.svg' : '../../../assets/images/icones/file-invoice-dollar-solid.svg'">
      </div>
    </div> -->
    <div *ngIf="!cadastroEmUso && exibirMenu('PORTAL DE ACOMPANHAMENTO DE PARCELAMENTO / ACORDOS')" class="servicos-item centralizar" (click)="abrirPortalAcompanhamento()" tabindex="0">
      <div class="row">
        <span class="servicos-item__texto-medio cardPortalAcompanhamento">PORTAL DE ACOMPANHAMENTO DE PARCELAMENTO /
          ACORDOS</span>
      </div>
      <div class="row">
        <span class="servicos-item__texto-menor ">Acompanhar pagamento e reemissão de parcelamentos</span>
      </div>
    </div>
    <div *ngIf="!cadastroEmUso && exibirMenu('CADASTRO DE CONTRIBUINTES DO I.C.M.S')">
      <div class="servicos-item centralizar" [class.disabled]="nivelContribuinte == 'bronze'"
        title="{{ nivelContribuinte !== 'bronze' ? 'Cadastro': 'Este recurso está disponível somente para os níveis Prata e Ouro do acesso Gov.br ' }}"
        [routerLink]="nivelContribuinte !== 'bronze' ? ['/cadastro'] : []">
        <div class="row">
          <span class="servicos-item__texto-maior col">CADASTRO DE CONTRIBUINTES DO I.C.M.S</span>
        </div>
        <div class="row">
          <span class="servicos-item__texto-menor col">Cadastramento, alteração e baixa de Pessoas Físicas e Jurídicas
            fora da REDESIM</span>
        </div>
      </div>
    </div>
    <div *ngIf="exibirMenu('IPVA')" class="servicos-item centralizar" (click)="abrirRefisIpva()" tabindex="0">
      <div class="row">
        <span class="servicos-item__texto-maior col mb-3">IPVA</span>
      </div>
      <div class="row">
        <span class="servicos-item__texto col">Como Pagar o IPVA</span>
      </div>
    </div>
    <div *ngIf="!cadastroEmUso && exibirMenu('PERFIL DO CONTRIBUINTE')" class="servicos-item centralizar" (click)="abrirPerfilContribuinte()">
      <div class="row">
        <span class="servicos-item__texto-maior col">PERFIL DO CONTRIBUINTE</span>
      </div>
      <div class="row">
        <span class="servicos-item__texto col">Seus dados Fiscais, podendo adicionar e-mail para
          alertas<br /><br /><br /><br /><br /></span>
      </div>
    </div>
    <div *ngIf="!cadastroEmUso" class="servicos-item centralizar" (click)="abrirGfis()">
      <div class="row">
        <span class="servicos-item__texto-maior col mb-3">GFIS</span>
      </div>
      <div class="row">
        <span class="servicos-item__texto col">Sistema de Gestão de Fiscalização<br /><br /><br /><br /><br /></span>
      </div>
    </div>
    <div *ngIf="!cadastroEmUso" class="servicos-item centralizar" (click)="abrirNfae()">
      <div class="row">
        <span class="servicos-item__texto-maior col mb-3">NFA-e</span>
      </div>
      <div class="row">
        <span class="servicos-item__texto col">Nota Fiscal Avulsa Eletrônica<br /><br /><br /><br /><br /></span>
      </div>
    </div>
    <div *ngIf="temAdesaoToLegal" class="servicos-item centralizar" (click)="abrirToLegal()" tabindex="0">
      <div class="row">
        <span class="servicos-item__texto-maior col mb-3">TÔ LEGAL</span>
      </div>
      <div class="row">
        <span class="servicos-item__texto col">Acompanhamento de Sorteio</span>
      </div>
    </div>


     <!-- <div class="servicos-item centralizar" (click)="abrirAnaliseFiscal()" tabindex="0">
      <div class="row">
        <span class="servicos-item__texto-maior col">ANÁLISE FISCAL</span>
      </div>
      <div class="row">
        <span class="servicos-item__texto col">Consulta da situação fiscal do contribuinte.</span>
      </div>
    </div> -->

  </div>
  <!-- Modal Negociação de Débito -->
  <div class="backdrop" *ngIf="modalAtivo">
    <div class="div br-modal medium position-modal">
      <div class="br-modal-header">Informativo
      </div>
      <div class="br-modal-body">
        <p>O Portal de Negociação apresenta dados e dívidas ativas lançadas até a data da pesquisa, não devendo presumir
          que é uma Certidão Negativa de Débito.</p>
      </div>
      <div class="br-modal-footer justify-content-end">
        <button class="botao-modoEscuro br-button primary ml-2" type="button" (click)="abrirNegociacaoDebito()">OK
        </button>
      </div>
    </div>
  </div>

  <div class="backdrop" @abrirTermo *ngIf="backdrop">
    <div class="div br-modal medium position-modal" *ngIf="!registroTermoAdesao && termoAdesao">
      <div class="br-modal-header">Termo de Adesão
      </div>
      <div class="br-modal-body">
        <p>{{ termoAdesao }}</p>
      </div>
      <div class="br-modal-footer justify-content-end">
        <button class="br-button secondary" type="button" (click)="termoNaoAceito()">Não
        </button>
        <button class="br-button primary ml-2" type="button" (click)="termoAceito()">Sim
        </button>
      </div>
    </div>
    <div class="div br-modal large position-modal" *ngIf="registroTermoAdesao">
      <div class="br-modal-header">Termo de Adesão
      </div>
      <div class="br-modal-body" (scroll)="scrollEnd($event)">
        <div [innerHTML]="termoAdesao" class="scroll-modal" (scroll)="scrollEnd($event)"></div>
      </div>
      <div class="br-modal-footer justify-content-center">
        <div class="row">
          <div class="br-checkbox col margin-checkbox">
            <input id="ciencia" name="ciencia" type="checkbox" [disabled]="!atBottom" (change)="termoAceito()" />
            <label for="ciencia">Li, estou ciente e de acordo.</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="backdrop" @abrirTermo *ngIf="abrirModalContatos">
    <div class="div br-modal medium position-modal">
      <div class="br-modal-header">Atualização de Contatos</div>
      <div class="br-modal-body">
        <form [formGroup]="formContatos">
          <div class="br-input col-8 mb-2">
            <label for="email">Email <span class="obrigatorio label">*</span></label>
            <input
              email
              formControlName="email"
              type="text"
              name="email"
              id="email"
              placeholder="Digite seu melhor e-mail"
            />
          </div>
          <p class="mensagem-erro" *ngIf="formContatos.controls.email.invalid && formContatos.controls.email.touched">
            Campo obrigatório
          </p>
          <div class="br-input col-4 mt-3 mb-2">
            <label for="telefone">Telefone <span class="obrigatorio label">*</span></label>
            <input
              formControlName="telefone"
              mask="(00) 00000-0000"
              type="text"
              name="telefone"
              id="telefone"
              placeholder="(00) 00000-0000"
            />
          </div>
          <p class="mensagem-erro" *ngIf="formContatos.controls.telefone.invalid && formContatos.controls.telefone.touched">
            Campo obrigatório
          </p>
          <p class="mensagem-erro mt-3">
           <b>Por favor, verifique se o e-mail e o número de telefone estão corretos antes de confirmar a atualização.</b>
         </p>
        </form>
      </div>
      <div class="br-modal-footer justify-content-end">
        <button
          class="br-button primary"
          type="button"
          [disabled]="this.formContatos.invalid"
          (click)="salvarContatos()"
        >Salvar Contatos</button>
      </div>
    </div>
  </div>
</section>
<div class="carregamento" *ngIf="loading">
  <img src="../../../assets/images/icones/logo-animado.svg">
</div>
